import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import { type GetPollsInteractor } from '../../../features/polls/domain/interactors/get-polls.interactor'
import { type GetPollInteractor } from '../../../features/polls/domain/interactors/get-poll.interactor'
import { type SavePollInteractor } from '../../../features/polls/domain/interactors/save-poll.interactor'
import { type ClosePollInteractor } from '../../../features/polls/domain/interactors/close-poll.interactor'
import { type DeletePollInteractor } from '../../../features/polls/domain/interactors/delete-poll.interactor'
import { type GetLinkablePostsInteractor } from '../../../features/polls/domain/interactors/get-linkable-posts.interactor'

interface PollsContextType {
  getPolls: GetPollsInteractor
  getPoll: GetPollInteractor
  savePoll: SavePollInteractor
  closePoll: ClosePollInteractor
  deletePoll: DeletePollInteractor
  getLinkablePosts: GetLinkablePostsInteractor
}

const PollsContext = createContext<PollsContextType>()

export const CorisPollsProvider = (props: { children: JSX.Element }): JSX.Element => {
  const component = MainModule.getPollsComponent()
  const value: PollsContextType = {
    getPolls: component.provideGetPolls(),
    getPoll: component.provideGetPoll(),
    savePoll: component.provideSavePoll(),
    closePoll: component.provideClosePoll(),
    deletePoll: component.provideDeletePoll(),
    getLinkablePosts: component.provideGetLinkablePosts()
  }
  return <PollsContext.Provider value={value}>{props.children}</PollsContext.Provider>
}

export const usePolls = (): PollsContextType => {
  const context = useContext(PollsContext)
  if (!context) throw new Error('usePolls must be used inside a CorisPollsProvider')
  return context
}
